/** Keep typed names readable while limiting room identities to letters and spaces. */
export function playerNameInput(value: string): string {
  return value.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z ]/g, "").replace(/ +/g, " ").slice(0, 28);
}

export function normalizedPlayerName(value: string): string {
  return playerNameInput(value).trim();
}

export function defaultPlayerName(value: string | null | undefined): string {
  return normalizedPlayerName(value || "") || "PLAYER";
}

export function validPlayerName(value: string): boolean {
  return value.length <= 28 && /^[A-Z]+(?: [A-Z]+)*$/.test(value);
}
